module.exports = __webpack_public_path__ + "static/Health-institute-8da489a2355f6cf09976fbe5ce06c7e3.svg";